import React, { useMemo } from 'react';
import { Highlight } from '@mantine/core';

import { useOrganisationSearch } from '../../context/OrganisationSearchContext';

const DIVISION_FIELDS = [
    // Max 24 columns
    { label: 'Name', colspan: 4 },
    { label: 'Speed Dial', colspan: 1 },
    { label: 'Tel', colspan: 3 },
    { label: 'Email', colspan: 5 },
    { label: 'Town & Address', colspan: 5 },
    { label: 'Manager', colspan: 5 },
];

type Props = {
    isProcurement?: boolean;
};

function DivisionsHeader({ isProcurement = false }: Props) {
    const { organisationSearch } = useOrganisationSearch();

    const fields = useMemo(() => {
        if (isProcurement) {
            return DIVISION_FIELDS.filter(
                ({ label }) =>
                    label !== 'Postal Code' &&
                    label !== 'Town & Address' &&
                    label !== 'Manager',
            ).map(({ label }) => {
                if (label === 'Email') {
                    return { label, colspan: 8 };
                }
                if (label === 'Speed Dial') {
                    return { label, colspan: 4 };
                }
                return { label, colspan: 6 };
            });
        }
        return DIVISION_FIELDS;
    }, []);

    return (
        <div className="w-full sticky top-[237px] z-10 pt-3 bg-[#f8f9fa]">
            <div className="w-full grid grid-cols-24 grid-rows-1 border-[0.5px] border-solid border-[#A7A7A7CC] bg-[#F1F0F4]">
                {fields.map(({ label, colspan }) => (
                    <div
                        key={label}
                        style={{
                            gridColumn: `span ${colspan}`,
                        }}
                        className="flex h-12 p-2 border-solid border-[0.5px] border-transparent border-r-[#A7A7A7CC] last-of-type:border-none items-center  whitespace-nowrap overflow-hidden text-ellipsis"
                    >
                        <Highlight
                            className="font-semibold text-sm break-words whitespace-normal"
                            highlight={organisationSearch}
                        >
                            {label}
                        </Highlight>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DivisionsHeader;
